import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button, IconButton } from "@mui/material";
import Add from "@mui/icons-material/Add";
import ModeEditOutlineTwoTone from "@mui/icons-material/ModeEditOutlineTwoTone";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import AppTable from "components/Shared/AppTable";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import TableFilter from "components/Shared/AppTable/TableFilter";

import { useLazyGetPaymentIntegrationListQuery } from "store/services/paymentIntegrationApi";

import { useAppMeta } from "hooks";

const PaymentIntegrationListScreen = () => {
  const breadcrumbs = [{ title: "Payment Integrations" }];

  const [searchParams] = useSearchParams();

  const keyword = searchParams.get("search") || "";

  const columns = [
    { name: "Provider", selector: (row) => row?.providers ?? "N/A" },
    {
      name: "Is Active",
      selector: (row) => (row?.isActive ? "Yes" : "No"),
    },
    {
      name: "Added Users",
      cell: (row) => (
        <div className="flex">
          {row?.addedUser?.slice(0, 2)?.map((user, index) => (
            <div key={user?._id}>
              {user?.name}
              {index < 1 && <span className="mr-1"></span>}
              {row?.addedUser?.length > 2 &&
                `& ${row?.addedUser?.length - 2} others`}
            </div>
          ))}
        </div>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <Link to={`/app/crm/paymentIntegration/${row._id}/detail`}>
            <IconButton color="primary" aria-label="View Payment Integration">
              <InfoOutlined />
            </IconButton>
          </Link>

          <Link to={`/app/crm/paymentIntegration/${row._id}/edit`}>
            <IconButton size="small" aria-label="Edit Payment Integration">
              <ModeEditOutlineTwoTone />
            </IconButton>
          </Link>
        </>
      ),
      ignoreRowClick: true,
      button: true,
    },
  ];

  // RTK Query
  const [
    fetchPaymentIntegrations,
    { data: paymentIntegrationList, isLoading: loadingPaymentIntegrations, error },
  ] = useLazyGetPaymentIntegrationListQuery();

  React.useEffect(() => {
    fetchPaymentIntegrations();
  }, [fetchPaymentIntegrations]);

  useAppMeta("Payment Integrations");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} headerActions={<PageActions />}>
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <TableFilter searchLabel="Provider">
          <div className="font-medium">Payment Integrations</div>
        </TableFilter>

        <AppTable
          columns={columns}
          data={
            paymentIntegrationList?.filter(
              (item) =>
                item && item.providers.toLowerCase().includes(keyword.toLowerCase())
            ) ?? []
          }
          progressPending={loadingPaymentIntegrations}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default PaymentIntegrationListScreen;

const PageActions = () => {
  return (
    <Link to="/app/crm/paymentIntegration/create">
      <Button startIcon={<Add />} variant="contained">
        New Payment Integration
      </Button>
    </Link>
  );
};